
import { Component, Vue, Prop } from 'vue-property-decorator'
import addClass from '@/views/goodsManage/commodity/subPage/addClass.vue'
import { categoryDto } from '@/api/goods'

@Component({
  components: {
    addClass
  }
})
export default class GoodsCategorySelect extends Vue {
  @Prop({ default: '' }) categoryId?: string
  $refs!: {
    addClass
  }
  visible = false

  showModal () {
    this.visible = true
    // this.$refs.addClass.getInfo()
  }
  handleBack () {
    this.$eventBus.$emit('currentPage', 1)
    this.visible = false
  }
  handleSelect (data: categoryDto) {
    this.$emit('on-select', data)
    this.visible = false
  }
}
